const Material = {
    0: 'Gelbgold',
    1: 'Rotgold',
    2: 'Weißgold',
    3: 'Chrom',
    4: 'Silber',
};

const Carat = {
    10: '8ct', // === NEU: 10 Karat ===
    14: '14ct',
    18: '18ct',
};

const Model = {
    0: 'Cap',
    1: 'Frame',
    2: 'Vamp',
};

const Gold = {
    0: 'NichtGold',
    1: 'Gelb',
    2: 'Rot',
    3: 'Weiß',
};

const materialToGold = {
    0: 1,
    1: 2,
    2: 3,
    3: 0,
    4: 0,
};

// === GEÄNDERT: chromePlating als optionaler Parameter ===
async function getVariantAttribute(toothNr, materialId, modelId, caratId, attribute, isBridge = false, chromePlating = 'none') {
    const model = Model[modelId];
    const goldId = materialToGold[materialId];
    const gold = Gold[goldId];

    try {
        const product = await getCachedResponseJson(
            window.Shopify.routes.root + 'products/' + getToothHandle(goldId, toothNr, materialId, caratId, isBridge, chromePlating)
        );

        const variant = product.variants.find((variant) => {
            return variant.option1 === model
                && variant.option2 === gold;
        });

        return variant?.[attribute];
    } catch (error) {
        console.error('Error fetching data:', error);
        return undefined;
    }
}

async function getDiamondAttributeByModel(attribute) {
    try {
        const product = await getCachedResponseJson(window.Shopify.routes.root + 'products/konfigurator-cap-diamond.js');
        return {
            0: product.variants.find(variant => { return variant.option1 === 'Cap'; })?.[attribute],
            1: product.variants.find(variant => { return variant.option1 === 'Frame'; })?.[attribute],
            2: product.variants.find(variant => { return variant.option1 === 'Vamp'; })?.[attribute],
        };
    } catch (error) {
        console.error('Error fetching data:', error);
        return undefined;
    }
}

// === GEÄNDERT: chromePlating als optionaler Parameter ===
function getToothHandle(goldId, toothNr, materialId, caratId, isBridge, chromePlating = 'none') {
    let materialProductName;
    if (isBridge) {
        materialProductName = 'bridge-';
    } else {
        materialProductName = toothNr + '-';
    }

    if (goldId === 0) {
        const baseName = Material[materialId].toLowerCase();
        if (chromePlating !== 'none') {
            // === NEU: z.B. konfigurator-cap-5-chrom-rosegold ===
            materialProductName += baseName + '-' + chromePlating;
        } else {
            materialProductName += baseName;
        }
    } else {
        materialProductName += 'gold-' + Carat[caratId];
    }

    return 'konfigurator-cap-' + materialProductName + '.js';
}

async function getCachedResponseJson(productUrl) {
    const cacheResponse = window.sessionStorage.getItem(productUrl);
    if (cacheResponse !== null) {
        return JSON.parse(cacheResponse);
    }

    const response = await fetch(productUrl);
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseJson = await response.json();

    window.sessionStorage.setItem(productUrl, JSON.stringify(responseJson));
    return responseJson;
}